import { Text, useDisclosure } from '@chakra-ui/react';
import { InteractiveTooltip } from 'app/components/Core/InteractiveTooltip';
import { GoToSong } from '../ReleaseErrorMsg';

interface ValidationTooltipProps {
  errorMsg: string;
  tab: 'details' | 'contributions' | 'lyrics' | 'splits';
}

export const ValidationTooltip = ({
  errorMsg,
  tab,
}: ValidationTooltipProps) => {
  const { onClose, onOpen, isOpen } = useDisclosure();

  return (
    <InteractiveTooltip
      variant="light"
      iconProps={{
        color: 'R.80',
        w: 5,
      }}
      popoverContentProps={{
        w: 'fit-content',
      }}
      popoverProps={{
        placement: 'bottom',
        onClose,
        onOpen,
        isOpen,
      }}
    >
      <Text fontSize="xs" fontWeight={500} color="black">
        {errorMsg}&nbsp;
        <GoToSong tab={tab} _hover={{ color: 'B.80' }} />
      </Text>
    </InteractiveTooltip>
  );
};
